var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpareparts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.01 3.98h56v56h-56z",
    fill: "#f00",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.99,
    cy: 31.98,
    fill: "#ff6700",
    opacity: 0.1,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.01 7.98h56v48h-56z",
    fill: "#f00",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.01 3.98h48v56h-48z",
    fill: "#ff2727",
    opacity: 0.21
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.17 8h-18.33a3.91 3.91 0 0 0 -3.84 4v40a3.91 3.91 0 0 0 3.83 4h18.34a3.92 3.92 0 0 0 3.83-4v-4.11a2 2 0 0 0 -4 0v4.11h-18v-40h18v3.89a2 2 0 1 0 4 0v-3.89a3.92 3.92 0 0 0 -3.83-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.13 8h-18.33a3.92 3.92 0 0 0 -3.8 4v3.94a2 2 0 1 0 4 0v-3.94h18v40h-18v-4a2 2 0 1 0 -4 0v4a3.92 3.92 0 0 0 3.83 4h18.3a3.92 3.92 0 0 0 3.87-4v-40a3.92 3.92 0 0 0 -3.87-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30 32a2 2 0 0 0 -2-2h-9.22l2.32-2.32a2 2 0 1 0 -2.83-2.83l-5.66 5.66v.06a2 2 0 0 0 -.26 2.56 2.88 2.88 0 0 0 .27.34l5.66 5.66a2 2 0 0 0 2.83-2.83l-2.35-2.3h9.24a2 2 0 0 0 2-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m34 32a2 2 0 0 0 2 2h9.19l-2.3 2.29a2 2 0 0 0 2.83 2.83l5.66-5.66a2.24 2.24 0 0 0 .27-.34 2 2 0 0 0 -.26-2.55v-.07l-5.66-5.66a2 2 0 0 0 -2.83 0 2 2 0 0 0 0 2.83l2.32 2.33h-9.22a2 2 0 0 0 -2 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpareparts);
export default __webpack_public_path__ + "static/media/spareparts.72fafa29.svg";
export { ForwardRef as ReactComponent };